import React, { memo } from "react";
import { Routes, Route } from "react-router-dom";
import { ApplicationAction, BusinessPage } from "core/constants";
import UrlUtils from "core/lib/url-utils";
import SignIn from "components/sign-in";
import SignOut from "components/sign-out";
import SignUp from "components/sign-up";
import AuthStyleWrapper from "components/ui/auth-style-wrapper";
import LinkUpCustomer from "self-service/account/link-up/link-up-customer";
import LinkUpCustomerLogic from "self-service/account/link-up/link-up-customer.logic";
import { useLocalObservable } from "mobx-react-lite";

const linkAccountUrl = `${UrlUtils.getRootPath()}${BusinessPage.accountLinkUp.substring(1)}?action=${ApplicationAction.redirectOnly}`;

const SignInOutLayout = () => {
    const linkUpLogic = useLocalObservable(() => new LinkUpCustomerLogic());

    return (
        <AuthStyleWrapper>
            <Routes>
                <Route path="in" element={<SignIn />} />
                <Route path="out" element={<SignOut />} />

                <Route path="up/link" element={<LinkUpCustomer logic={linkUpLogic} currentUserCheck={true} />} />
                <Route path="up/link/additional" element={<LinkUpCustomer logic={linkUpLogic} currentUserCheck={false} />} />
                <Route path="up/then/link" element={<SignUp returnUrl={linkAccountUrl} />} />
                <Route path="in/then/link" element={<SignIn returnUrl={linkAccountUrl} />} />
            </Routes>
        </AuthStyleWrapper>
    );
}

export default memo(SignInOutLayout);
